import React from 'react'
import '../CSS/404.css'
import { Link } from 'react-router-dom';

export default function PageNotFound() {
    return (
        <div className='container-fluid timepass'>
            <div className="container-sm">
                <h1 className="error-code">404</h1>
                <p className="error-message">Oops! Page not found.</p>
                <Link className="back-link" to="/">Go back to the homepage</Link>
            </div>
        </div>
    )
}
